import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { RecentOrFavoriteOrder } from '@/models';

@Component({
  name: 'CmgIneligibleOrderCard',
})
export default class CmgIneligibleOrderCard extends Vue {
  @Prop({ required: true, type: Boolean })
  isFavorite!: boolean;

  @Prop({ required: false, type: Object })
  order!: RecentOrFavoriteOrder;

  get favoriteIconUrl(): string {
    return this.isFavorite ? this.$appStore.state.cms.images.icons.heartFilled.default : this.$appStore.state.cms.images.icons.heartEmpty.default;
  }

  get favoriteLabel(): string {
    return this.isFavorite ? 'Remove the Favorite' : 'Make it Favorite';
  }

  onClickFavoriteToggle() {
    this.$emit('toggle-favorite', {});
    Vue.nextTick(() => {
      setTimeout(() => {
        const focusNearby = document.getElementsByClassName('favCard')[0] as HTMLElement;
        if (focusNearby) {
          const focusFirstelement = focusNearby.getElementsByClassName('name')[0] as HTMLElement;
          focusFirstelement.focus();
        }
        const focusNearbyhome = document.getElementsByClassName('favhome')[0] as HTMLElement;
        if (focusNearbyhome) {
          const focusFirstelement = focusNearbyhome.getElementsByClassName('name')[0] as HTMLElement;
          focusFirstelement.focus();
        }
        const nosaveFav = document.getElementsByClassName('nosavedFav')[0] as HTMLElement;
        if (nosaveFav) {
          nosaveFav.focus();
        }
      }, 1000);
    });
  }
}
